import { getAuthAxiosBackend } from "@/helpers/axios"

class RegionsServices {
    get(id) {
        return getAuthAxiosBackend().get('Regions/getRegion/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Regions/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('Regions/addRegion', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('Regions/updateRegions/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('Regions/restoreRegion' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('Regions/softDeleteRegion/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('Regions/deleteRegion/' + id.toString())
    }
}

export default new RegionsServices()